/* RESPONSIBLE TEAM: team-actions */
import AppstoreAppPackageBaseRoute from 'embercom/routes/base/appstore/app-package';

export default AppstoreAppPackageBaseRoute;
